import React, { useContext } from 'react'
import urls from '../../../utils/constants/urls'
import Grid from '../../elem/grid/display/Grid'
import PageLayout from '../../elem/Layout'
import { DataContext } from './DataContext'

const Invoices = () => {
    const { listMetadata, updateQueryParameters, queryParameters, invoices, loading, gridConfig, gridConfigExpanded, createLink } = useContext(DataContext)

    return (
        <PageLayout returnUrl={urls.home}>
                <Grid
                    metaData={listMetadata}
                    updateQueryParameters={updateQueryParameters}
                    queryParameters={queryParameters}
                    data={invoices}
                    gridConfig={gridConfig}
                    name={'invoices'}
                    loading={loading}
                    gridConfigExpanded={gridConfigExpanded}
                    createLink={createLink}
                />
        </PageLayout>
    )
}

export default Invoices
